import React from 'react';
import { FlameIcon, StarIcon } from 'lucide-react';
import { Accent, SectionHeading } from './SectionHeading';
import { volumes } from '../../data/content';
export function VolumesSection() {
  return <section aria-labelledby="volumes-heading" className="bg-brand-paper px-5 py-16 lg:px-8 lg:py-24" data-id="element-191" data-mp="3yjwa8owtzig">
      <div className="mx-auto max-w-6xl" data-id="element-192" data-mp="7ylq5voelon6">
        <SectionHeading id="volumes-heading" eyebrow="6 Structured Volumes" title={<>
              Your Complete Cosmetology <Accent data-id="element-194" data-mp="10mzmm6zugcwm">Teaching System</Accent>
            </>} data-id="element-193" data-mp="81g89gjy2xdf" />

        <ol className="mt-12 grid gap-5 sm:grid-cols-2 lg:grid-cols-3" role="list" data-id="element-195" data-mp="mx5xrooc9smw">
          {volumes.map(volume => {
          const isLead = volume.number === 1;
          return <li key={volume.number} className={`flex h-full flex-col overflow-hidden rounded-[20px] bg-white shadow-[0_24px_50px_-36px_rgba(70,50,110,0.45)] ${isLead ? 'sm:col-span-2 lg:row-span-2' : ''} ${volume.number === 6 ? 'sm:col-span-2 lg:col-span-1' : ''}`} data-id="element-196" data-mp="1eo29un2krt94">
                <div className={`flex flex-col px-6 pb-6 pt-5 ${isLead ? 'min-h-[220px] flex-1 sm:px-10 sm:pb-10 sm:pt-8' : 'min-h-[170px]'}`} style={{
              backgroundColor: volume.accent
            }} data-id="element-197" data-mp="7nrb4be19t61">
                  <div className="flex items-center gap-2" data-id="element-198" data-mp="vbhbvnqavcex">
                    <span className="rounded-full bg-white/75 px-3 py-1 font-body text-[10px] font-bold uppercase tracking-[0.2em] text-brand-charcoal/75" data-id="element-199" data-mp="v9xvlx4n91d5">
                      Volume {volume.number}
                    </span>
                    {volume.mark === 'star' && <StarIcon className="h-4 w-4 fill-brand-gold text-brand-gold" strokeWidth={1.5} aria-label="Key volume" data-id="element-200" data-mp="10c5df3c5nbne" />}
                    {volume.mark === 'flame' && <FlameIcon className="h-4 w-4 text-brand-violet" strokeWidth={2} aria-label="High-impact volume" data-id="element-201" data-mp="323iefhb04ze6" />}
                  </div>
                  {isLead && <span aria-hidden="true" className="mt-6 font-display text-[6rem] font-bold leading-none text-brand-gold sm:text-[8rem]" data-id="element-202" data-mp="1ayygli8n24jm">
                      1
                    </span>}
                  <h3 className={`mt-auto pt-6 font-display font-bold leading-[1.1] text-brand-charcoal ${isLead ? 'text-[2rem] sm:text-[2.6rem]' : 'text-[1.55rem]'}`} data-id="element-203" data-mp="1oyq181tnuj6l">
                    {volume.title}
                  </h3>
                </div>
                <p className={`px-6 py-5 leading-relaxed text-brand-charcoal/65 ${isLead ? 'text-[15px] sm:px-10 sm:py-7 sm:text-[16px]' : 'flex-1 text-[14px]'}`} data-id="element-204" data-mp="22oti0d9rtkon">
                  {volume.description}
                </p>
              </li>;
        })}
        </ol>
      </div>
    </section>;
}